import moment from 'moment-timezone';

export const getCurrentDate = () => moment()
  .format('YYYY-MM-DD')
  .toString();

export const getCurrentDatetime = () => moment()
  .format('YYYY-MM-DD HH:mm:ss')
  .toString();
